import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

type IPaginate = {
  current_page: number;
  last_page: number;
  onNext: (page: number) => void;
  onPrev: (page: number) => void;
};

const Paginate: React.FC<IPaginate> = ({
  current_page,
  last_page,
  onNext,
  onPrev,
}) => {
  const isFirst = current_page <= 1;
  const isLast = current_page >= last_page;

  return (
    <div className="flex items-center justify-end gap-3">
      <button
        onClick={() => !isFirst && onPrev(current_page - 1)}
        disabled={isFirst}
        className="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium border border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:border-gray-200 transition-all duration-150"
      >
        <FaArrowLeft className="text-xs" />
        Prev
      </button>

      <span className="text-sm text-gray-500 tabular-nums">
        <span className="font-semibold text-gray-800">{current_page}</span>
        <span className="mx-1.5">/</span>
        {last_page}
      </span>

      <button
        onClick={() => !isLast && onNext(current_page + 1)}
        disabled={isLast}
        className="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium border border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:border-gray-200 transition-all duration-150"
      >
        Next
        <FaArrowRight className="text-xs" />
      </button>
    </div>
  );
};

export default Paginate;
